import isEmpty from 'lodash/isEmpty'
import isEqual from 'lodash/isEqual'
import pick from 'lodash/pick'
import omitBy from 'lodash/omitBy'
import querystring from 'query-string'
import undefsafe from 'undefsafe'

import searchQueryWhitelist from '../constants/searchQueryWhitelist'
import filterParamsConfig from '../constants/filterParamsConfig'
import siteConfigUtil from './siteConfig'

export const isCategoryOnlySearch = (query) => {
  return includesExactlyTheseFacetingParams(query, [ 'category' ])
}

export const isFirstPage = (query) => {
  return isEmpty(query.page) || [ 0, 1 ].includes(parseInt(query.page))
}

export const includesExactlyTheseFacetingParams = (query, expectedParamKeys) => {
  const queryFacetingParams = pick(query, facetingParams)
  const queryFacetingParamsWithValues = omitBy(queryFacetingParams, isEmpty)
  const facetingParamKeys = Object.keys(queryFacetingParamsWithValues)

  return isEqual(facetingParamKeys.sort(), expectedParamKeys.sort())
}

const facetingParams = [
  'term',
  'sizes',
  'username',
  'price_min',
  'price_max',
  'length_min',
  'length_max',
  'sales_min',
  'sales_max',
  'sales',
  'poly_count',
  'rating_min',
  'item_id',
  'item_ids',
  'tags',
  'file_type',
  'category',
  'platform',
  'colours',
  'attribute_key',
  'attribute_value',
  'length_min',
  'length_max',
  'tempo',
  'orientation',
  'stock_footage_number_of_people',
  'alpha',
  'looped',
  'requires_plugins',
  'resolution_min',
  'vocals_in_audio',
  'frame_rate',
  'compatible_with',
  'date',
  'include_pro_affiliated'
]

/**
 * Build the search query string
 * @param  {Object} query
 * @return {String} the search query string pass to public-search
 */
export const buildSearchQueryString = (parsedLocation, currentSite) => {
  const filteredQueryObject = Object.keys(parsedLocation)
    .filter(param => {
      // only keep the queries in the public-search query whitelist
      return searchQueryWhitelist.indexOf(param) >= 0
    }).filter(param => {
      // filter empty params
      return !!parsedLocation[param]
    }).reduce((prev, curr) => {
      if (Array.isArray(parsedLocation[curr])) {
        const arrayLenght = parsedLocation[curr].length
        prev[curr] = parsedLocation[curr][arrayLenght - 1]
      } else if (undefsafe(filterParamsConfig, `${curr}.isArrayFormat`)) {
        prev[curr] = parsedLocation[curr].split(',')
      } else {
        prev[curr] = parsedLocation[curr]
      }
      return prev
    }, {})

  const pageSize = siteConfigUtil(currentSite, 'common.search_page_size')
  const site = `${currentSite}.net`

  // we have a few default value here
  const newQueryObject = Object.assign({}, filteredQueryObject, {
    site,
    page: filteredQueryObject.page || 1,
    page_size: filteredQueryObject.page_size || pageSize
  })

  return querystring.stringify(newQueryObject, {arrayFormat: 'bracket'})
}



// WEBPACK FOOTER //
// ./common/utils/searchQueryHelper.js